import React, { useEffect, useState } from 'react';
import cross from '../../resources/icons/ico_X.svg';
import circle from '../../resources_membership_hotel/icons/ico_circle.svg';
import minus from '../../resources_membership_hotel/icons/ico_minus.svg';
import slash from '../../resources_membership_hotel/icons/ico_slash.svg';
import square from '../../resources_membership_hotel/icons/ico_square.svg';
import triangle from '../../resources_membership_hotel/icons/ico_triangle.svg';
import { Label } from '../atoms/label';
import { Link } from '../atoms/link';
export const WeeksDateMobile = (props) => {

    const [week1, setWeek1] = useState([]);

    useEffect(() => {
        const arry1 = props.data.slice(0, 7);
        setWeek1(arry1);
    }, [props]);

    const cols1 = week1.map((value, index) =>
        <th key={value.date + index} style={value.color == "black" ? styles.tdStyleBlack : (value.color == "red" ? styles.tdStyleRed : styles.tdStyleBlue)}>
            <Label label={value.day} style={styles.font} />
            <Label label={value.week} style={styles.fontWeek} />
        </th>
    );

    const date = props.data2.map((value, index) =>
        <tr key={value.facilityId + index}>
            <td style={styles.title} onClick={() => props.onClickFacility(value.facilityId, value.facilityName)}>
                <Label label={value.facilityName} />
            </td>
            <td style={value.vacancyDateList[0].kushitsuMark === "○" || value.vacancyDateList[0].kushitsuMark === "△" || value.vacancyDateList[0].kushitsuMark === "□" || value.vacancyDateList[0].kushitsuMark === "占" ?
                (value.vacancyDateList[0].iroKbn == "gold" ? (styles.tdGold)
                    : (value.vacancyDateList[0].iroKbn == "red" ? (styles.tdRed)
                        : (value.vacancyDateList[0].iroKbn == "blue" ? (styles.tdBlue)
                            : (styles.tdWhite))))
                : (styles.tdNg)}>
                {value.vacancyDateList[0].kushitsuMark === "○" ? (
                    <Link style={styles.circle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[0].riyoDate) }} />
                ) : (value.vacancyDateList[0].kushitsuMark === "△" ? (
                    <Link style={styles.triangle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[0].riyoDate) }} />
                ) : (value.vacancyDateList[0].kushitsuMark === "□" ? (
                    <Link style={styles.square} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[0].riyoDate) }} />
                ) : (value.vacancyDateList[0].kushitsuMark === "×" ? (
                    <Label style={styles.cross} />
                ) : (value.vacancyDateList[0].kushitsuMark === "－" ? (
                    <Label style={styles.minus} />
                ) : (value.vacancyDateList[0].kushitsuMark === "占" ? (
                    <Link style={styles.occupy} linkTitle="占" onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[0].riyoDate) }} />
                ) : (
                    <Label style={styles.slash} />
                ))))))}
            </td>
            <td style={value.vacancyDateList[1].kushitsuMark === "○" || value.vacancyDateList[1].kushitsuMark === "△" || value.vacancyDateList[1].kushitsuMark === "□" || value.vacancyDateList[1].kushitsuMark === "占" ?
                (value.vacancyDateList[1].iroKbn == "gold" ? (styles.tdGold)
                    : (value.vacancyDateList[1].iroKbn == "red" ? (styles.tdRed)
                        : (value.vacancyDateList[1].iroKbn == "blue" ? (styles.tdBlue)
                            : (styles.tdWhite))))
                : (styles.tdNg)}>
                {value.vacancyDateList[1].kushitsuMark === "○" ? (
                    <Link style={styles.circle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[1].riyoDate) }} />
                ) : (value.vacancyDateList[1].kushitsuMark === "△" ? (
                    <Link style={styles.triangle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[1].riyoDate) }} />
                ) : (value.vacancyDateList[1].kushitsuMark === "□" ? (
                    <Link style={styles.square} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[1].riyoDate) }} />
                ) : (value.vacancyDateList[1].kushitsuMark === "×" ? (
                    <Label style={styles.cross} />
                ) : (value.vacancyDateList[1].kushitsuMark === "－" ? (
                    <Label style={styles.minus} />
                ) : (value.vacancyDateList[1].kushitsuMark === "占" ? (
                    <Link style={styles.occupy} linkTitle="占" onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[1].riyoDate) }} />
                ) : (
                    <Label style={styles.slash} />
                ))))))}
            </td>
            <td style={value.vacancyDateList[2].kushitsuMark === "○" || value.vacancyDateList[2].kushitsuMark === "△" || value.vacancyDateList[2].kushitsuMark === "□" || value.vacancyDateList[2].kushitsuMark === "占" ?
                (value.vacancyDateList[2].iroKbn == "gold" ? (styles.tdGold)
                    : (value.vacancyDateList[2].iroKbn == "red" ? (styles.tdRed)
                        : (value.vacancyDateList[2].iroKbn == "blue" ? (styles.tdBlue)
                            : (styles.tdWhite))))
                : (styles.tdNg)}>
                {value.vacancyDateList[2].kushitsuMark === "○" ? (
                    <Link style={styles.circle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[2].riyoDate) }} />
                ) : (value.vacancyDateList[2].kushitsuMark === "△" ? (
                    <Link style={styles.triangle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[2].riyoDate) }} />
                ) : (value.vacancyDateList[2].kushitsuMark === "□" ? (
                    <Link style={styles.square} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[2].riyoDate) }} />
                ) : (value.vacancyDateList[2].kushitsuMark === "×" ? (
                    <Label style={styles.cross} />
                ) : (value.vacancyDateList[2].kushitsuMark === "－" ? (
                    <Label style={styles.minus} />
                ) : (value.vacancyDateList[2].kushitsuMark === "占" ? (
                    <Link style={styles.occupy} linkTitle="占" onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[2].riyoDate) }} />
                ) : (
                    <Label style={styles.slash} />
                ))))))}
            </td>
            <td style={value.vacancyDateList[3].kushitsuMark === "○" || value.vacancyDateList[3].kushitsuMark === "△" || value.vacancyDateList[3].kushitsuMark === "□" || value.vacancyDateList[3].kushitsuMark === "占" ?
                (value.vacancyDateList[3].iroKbn == "gold" ? (styles.tdGold)
                    : (value.vacancyDateList[3].iroKbn == "red" ? (styles.tdRed)
                        : (value.vacancyDateList[3].iroKbn == "blue" ? (styles.tdBlue)
                            : (styles.tdWhite))))
                : (styles.tdNg)}>
                {value.vacancyDateList[3].kushitsuMark === "○" ? (
                    <Link style={styles.circle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[3].riyoDate) }} />
                ) : (value.vacancyDateList[3].kushitsuMark === "△" ? (
                    <Link style={styles.triangle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[3].riyoDate) }} />
                ) : (value.vacancyDateList[3].kushitsuMark === "□" ? (
                    <Link style={styles.square} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[3].riyoDate) }} />
                ) : (value.vacancyDateList[3].kushitsuMark === "×" ? (
                    <Label style={styles.cross} />
                ) : (value.vacancyDateList[3].kushitsuMark === "－" ? (
                    <Label style={styles.minus} />
                ) : (value.vacancyDateList[3].kushitsuMark === "占" ? (
                    <Link style={styles.occupy} linkTitle="占" onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[3].riyoDate) }} />
                ) : (
                    <Label style={styles.slash} />
                ))))))}
            </td>
            <td style={value.vacancyDateList[4].kushitsuMark === "○" || value.vacancyDateList[4].kushitsuMark === "△" || value.vacancyDateList[4].kushitsuMark === "□" || value.vacancyDateList[4].kushitsuMark === "占" ?
                (value.vacancyDateList[4].iroKbn == "gold" ? (styles.tdGold)
                    : (value.vacancyDateList[4].iroKbn == "red" ? (styles.tdRed)
                        : (value.vacancyDateList[4].iroKbn == "blue" ? (styles.tdBlue)
                            : (styles.tdWhite))))
                : (styles.tdNg)}>
                {value.vacancyDateList[4].kushitsuMark === "○" ? (
                    <Link style={styles.circle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[4].riyoDate) }} />
                ) : (value.vacancyDateList[4].kushitsuMark === "△" ? (
                    <Link style={styles.triangle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[4].riyoDate) }} />
                ) : (value.vacancyDateList[4].kushitsuMark === "□" ? (
                    <Link style={styles.square} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[4].riyoDate) }} />
                ) : (value.vacancyDateList[4].kushitsuMark === "×" ? (
                    <Label style={styles.cross} />
                ) : (value.vacancyDateList[4].kushitsuMark === "－" ? (
                    <Label style={styles.minus} />
                ) : (value.vacancyDateList[4].kushitsuMark === "占" ? (
                    <Link style={styles.occupy} linkTitle="占" onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[4].riyoDate) }} />
                ) : (
                    <Label style={styles.slash} />
                ))))))}
            </td>
            <td style={value.vacancyDateList[5].kushitsuMark === "○" || value.vacancyDateList[5].kushitsuMark === "△" || value.vacancyDateList[5].kushitsuMark === "□" || value.vacancyDateList[5].kushitsuMark === "占" ?
                (value.vacancyDateList[5].iroKbn == "gold" ? (styles.tdGold)
                    : (value.vacancyDateList[5].iroKbn == "red" ? (styles.tdRed)
                        : (value.vacancyDateList[5].iroKbn == "blue" ? (styles.tdBlue)
                            : (styles.tdWhite))))
                : (styles.tdNg)}>
                {value.vacancyDateList[5].kushitsuMark === "○" ? (
                    <Link style={styles.circle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[5].riyoDate) }} />
                ) : (value.vacancyDateList[5].kushitsuMark === "△" ? (
                    <Link style={styles.triangle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[5].riyoDate) }} />
                ) : (value.vacancyDateList[5].kushitsuMark === "□" ? (
                    <Link style={styles.square} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[5].riyoDate) }} />
                ) : (value.vacancyDateList[5].kushitsuMark === "×" ? (
                    <Label style={styles.cross} />
                ) : (value.vacancyDateList[5].kushitsuMark === "－" ? (
                    <Label style={styles.minus} />
                ) : (value.vacancyDateList[5].kushitsuMark === "占" ? (
                    <Link style={styles.occupy} linkTitle="占" onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[5].riyoDate) }} />
                ) : (
                    <Label style={styles.slash} />
                ))))))}
            </td>
            <td style={value.vacancyDateList[6].kushitsuMark === "○" || value.vacancyDateList[6].kushitsuMark === "△" || value.vacancyDateList[6].kushitsuMark === "□" || value.vacancyDateList[6].kushitsuMark === "占" ?
                (value.vacancyDateList[6].iroKbn == "gold" ? (styles.tdGold)
                    : (value.vacancyDateList[6].iroKbn == "red" ? (styles.tdRed)
                        : (value.vacancyDateList[6].iroKbn == "blue" ? (styles.tdBlue)
                            : (styles.tdWhite))))
                : (styles.tdNg)}>
                {value.vacancyDateList[6].kushitsuMark === "○" ? (
                    <Link style={styles.circle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[6].riyoDate) }} />
                ) : (value.vacancyDateList[6].kushitsuMark === "△" ? (
                    <Link style={styles.triangle} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[6].riyoDate) }} />
                ) : (value.vacancyDateList[6].kushitsuMark === "□" ? (
                    <Link style={styles.square} onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[6].riyoDate) }} />
                ) : (value.vacancyDateList[6].kushitsuMark === "×" ? (
                    <Label style={styles.cross} />
                ) : (value.vacancyDateList[6].kushitsuMark === "－" ? (
                    <Label style={styles.minus} />
                ) : (value.vacancyDateList[6].kushitsuMark === "占" ? (
                    <Link style={styles.occupy} linkTitle="占" onClick={() => { props.onClick(value.facilityId, value.vacancyDateList[6].riyoDate) }} />
                ) : (
                    <Label style={styles.slash} />
                ))))))}
            </td>
        </tr>
    );

    console.log("data値");

    return (
        <table style={styles.table}>
            <tbody>
                <tr>
                    <th style={styles.headerStyle} >
                        <Label label="ホテル名" />
                    </th>
                    {cols1}
                </tr>
                {date}
            </tbody>
        </table>
    );
}
const styles = {
    table: {
        borderCollapse: "collapse",
        width: "100%",
        position: "relative",
    },
    headerStyle: {
        height: "50px",
        width: "37%",
        textAlign: "left",
        // padding: "1%",
        fontSize: "small",
        fontWeight: "bold",
        backgroundColor: "#f6f6f6",
        color: "rgb(111, 111, 111)",
        position: "sticky",
        top: "0px",
        margin: "-1px",
        fontSize: "0.7rem",
        outline: "1px solid rgb(184, 183, 183)",
        padding: "3%",
    },
    // dateStyle: {
    //     border: "solid 1px #b8b7b7",
    //     height: "30px",
    //     width: "70%",
    //     textAlign: "center",
    // },
    tdStyleBlack: {
        height: "40px",
        width: "9%",
        textAlign: "center",
        // padding: "1%",
        fontSize: "small",
        fontWeight: "bold",
        backgroundColor: "#f6f6f6",
        color: "rgb(111, 111, 111)",
        position: "sticky",
        top: "0px",
        outline: "1px solid rgb(184, 183, 183)",
        zIndex: "1"
    },

    tdStyleBlue: {
        height: "40px",
        width: "9%",
        textAlign: "center",
        color: "blue",
        // padding: "1%",
        fontSize: "small",
        fontWeight: "bold",
        backgroundColor: "#f6f6f6",
        position: "sticky",
        top: "0px",
        outline: "1px solid rgb(184, 183, 183)",
        zIndex: "1"
    },
    tdStyleRed: {
        height: "auto",
        width: "9%",
        textAlign: "center",
        color: "red",
        // padding: "1%",
        fontSize: "small",
        fontWeight: "bold",
        backgroundColor: "#f6f6f6",
        position: "sticky",
        top: "0px",
        outline: "1px solid rgb(184, 183, 183)",
        zIndex: "1"
    },
    font: {
        fontSize: "small",
    },
    fontWeek: {
        fontSize: "0.8rem",
        fontWeight: "normal",
        color: "rgb(111, 111, 111)",
    },
    circle: {
        backgroundImage: `url(${circle})`,
        height: 13,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        cursor: "pointer",
    },
    triangle: {
        backgroundImage: `url(${triangle})`,
        height: 13,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        cursor: "pointer",
    },
    square: {
        backgroundImage: `url(${square})`,
        height: 13,
        width: 13,
        margin: "0 auto",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        cursor: "pointer",
    },
    cross: {
        backgroundImage: `url(${cross})`,
        height: 13,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        opacity: "0.5",
    },
    minus: {
        backgroundImage: `url(${minus})`,
        height: 13,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        opacity: "0.5",
    },
    slash: {
        backgroundImage: `url(${slash})`,
        height: 13,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        opacity: "0.5",
    },
    occupy: {
        border: "0px",
        display: "block",
        cursor: "pointer",
    },
    title: {
        borderLeft: "solid 1px #b8b7b7",
        borderRight: "solid 1px #b8b7b7",
        borderBottom: "solid 1px #b8b7b7",
        width: "37%",
        height: "30px",
        padding: "3%",
        backgroundColor: "white",
        fontSize: "0.7rem",
        marginLeft: "-2px",
        cursor: "pointer",
        textAlign: "left",
        whiteSpace: "pre-wrap",
    },
    tdBlue: {
        backgroundColor: "#7fbfff",
        borderRight: "1px solid rgb(184, 183, 183)",
        borderBottom: "1px solid rgb(184, 183, 183)",
    },
    tdGold: {
        backgroundColor: "#c0b283",
        borderRight: "1px solid rgb(184, 183, 183)",
        borderBottom: "1px solid rgb(184, 183, 183)",
    },
    tdRed: {
        backgroundColor: "#ff7f7f",
        borderRight: "1px solid rgb(184, 183, 183)",
        borderBottom: "1px solid rgb(184, 183, 183)",
    },
    tdWhite: {
        backgroundColor: "white",
        borderRight: "1px solid rgb(184, 183, 183)",
        borderBottom: "1px solid rgb(184, 183, 183)",
    },
    tdNg: {
        background: "rgb(0, 0, 0, 0.1)",
        borderRight: "1px solid rgb(184, 183, 183)",
        borderBottom: "1px solid rgb(184, 183, 183)",
        width: "9%",
    }
}